import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeTaskStatus(request: Boundaries["removeTaskStatus"]["request"]): void;
}

function useRemoveTaskStatus(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isRemoveTaskStatusRequestPending),
    isRequestSuccess: useSelector(selector.isRemoveTaskStatusRequestSuccess),
    isRequestFailure: useSelector(selector.isRemoveTaskStatusRequestFailure),
    removeTaskStatus: core.removeTaskStatus,
  };
}

export { useRemoveTaskStatus };
